import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 获取部门列表
 */
export function getDepartmentList(data) {
  return fetch ({
    url: '/auth/subPlatform/department/list',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取部门Tree
 */
export function getDepartmentTree(data) {
  return fetch ({
    url: '/auth/subPlatform/department/getDepartmentTree',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 添加部门
 */
export function addDepartment(data) {
  return fetch({
    url: '/auth/subPlatform/department/save',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除部门
 */
export function deleteDepartment(data) {
  return fetch({
    url: '/auth/subPlatform/department/delete',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 导出部门
 */
export function exportDepartment(data) {
  return formAxios({
    url: '/auth/unit/exportDepartmentList',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 编辑部门
 */
export function editDepartment(data) {
  return fetch({
    url: '/auth/subPlatform/department/save',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 根据部门id获取项目
 */
export function getProjectIdByDepartment(data) {
  return fetch({
    url: '/auth/department/getProjectIdByDepartment',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 根据unitId和部门id获取项目
 */
export function getProjectLiftTree(params) {
  return fetch({
    url: '/maintain/project/projectLiftTree',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} params
 * 根据部门id获取部门详情
 */
export function getDepartmentDetail(params) {
  return fetch({
    url: '/auth/department/detail',
    method: 'GET',
    params
  })
}




// WEBPACK FOOTER //
// ./src/api/DepartmentManagement/index.js